import { Locale } from '@yi/core';

export function getImageSrc(locale: Locale): string {
  if (locale === 'es') {
    return 'https://images.ctfassets.net/p0sybd6jir6r/P7AjQ89Q3KIRJneMzo2LH/19b7361298518a0221ada1cbfa419ca7/series-image-spanish.png';
  }

  return 'https://images.ctfassets.net/p0sybd6jir6r/1F7XrgELUs8XoCfKbB50Kc/dec8b4bc4b244bb37759f07e7b2b0ec0/series-image.png';
}
